enum LeadClassification {
  GOOD = "Good",
  BAD = "Bad",
  DECENT = "Decent",
  UNKNOWN = "Unknown",
}

export { LeadClassification };
